;(() => {
	const SELECTOR = '.footer .accordion details'
	const MOBILE_BREAKPOINT = 576

	const initAccordion = () => {
		const details = document.querySelectorAll(SELECTOR)

		if (window.innerWidth < MOBILE_BREAKPOINT) {
			details.forEach((detail) => detail.setAttribute('open', ''))
		} else {
			details.forEach((detail) => detail.removeAttribute('open'))
		}

		details.forEach((detail) => {
			if (detail.dataset.accordionInit) return

			detail.addEventListener('click', () => {
				details.forEach((item) => {
					if (item !== detail) item.removeAttribute('open')
				})
			})

			detail.dataset.accordionInit = 'true'
		})
	}

	document.addEventListener('shopify:section:load', initAccordion)
	window.addEventListener('resize', initAccordion)

	initAccordion()
})()
